/**
 * StatusCarga
 * @author Simpli CLI generator
 */
import {$, ID, Resource, TAG} from 'simpli-web-sdk'
import {
  ValidationMaxLength,
  ValidationRequired,
} from 'simpli-web-sdk'
import StatusCargaSchema from '@/schema/StatusCarga.schema'

export default class StatusCarga extends Resource {
  readonly $name: string = 'StatusCarga'

  readonly $endpoint: string = '/user/status-carga{/id}'

  get $schema() {
    return StatusCargaSchema(this)
  }

  get $id() {
    return this.idStatusPk
  }
  set $id(val: ID) {
    this.idStatusPk = val
  }
  get $tag() {
    return this.nome
  }
  set $tag(val: TAG) {
    this.nome = val
  }

  idStatusPk: ID = 0

  @ValidationRequired()
  @ValidationMaxLength(100)
  nome: string = ''

  @ValidationRequired()
  ativo: boolean = false

  async persistStatusCarga(model?: StatusCarga, spinner = 'persistStatusCarga') {
    const fetch = async () => {
      if (model) await model.validate()
      return await this.POST(`/user/status-carga`, model)
    }

    return await $.await.run(fetch, spinner)
  }

  async getStatusCarga(id: number, spinner = 'getStatusCarga') {
    const fetch = async () => await this.GET(`/user/status-carga/${id}`)
    return await $.await.run(fetch, spinner)
  }

  async removeStatusCarga(id: number, spinner = 'removeStatusCarga') {
    const fetch = async () => await this.DELETE(`/user/status-carga/${id}`)
    return await $.await.run(fetch, spinner)
  }
}
